import { render, staticRenderFns } from "./JLayoutNew.vue?vue&type=template&id=5278df04&scoped=true&"
import script from "./JLayoutNew.vue?vue&type=script&lang=js&"
export * from "./JLayoutNew.vue?vue&type=script&lang=js&"
import style0 from "./JLayoutNew.vue?vue&type=style&index=0&id=5278df04&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5278df04",
  null
  
)

export default component.exports